import React from 'react';
import { FlagsObject } from './types';

export const FlagContext = React.createContext<FlagsObject>({});
FlagContext.displayName = 'FlagContext';
